import { Card, Flex, Upload } from 'antd'
import { UploadFile } from 'antd/lib'
import { useParams } from 'react-router-dom'

import {
  usePersonsServiceGetPersonEndpoint,
  useQuestionnairesServiceGetQuestionnaireAnswerEndpoint,
  useQuestionnairesServiceGetQuestionnaireEndpoint
} from 'src/api/queries'
import { MediaFileResponse3 } from 'src/api/requests'
import { CustomItemRender, LoadingScreen } from 'src/components'
import { mapAnswersToQuizDetails } from 'src/features/persons/components/PersonQuiz'
import { QuizDetailsForm } from 'src/features/persons/components/PersonQuiz/components'
import { useStyles } from 'src/features/questionnaires/components/Preview/components/AnswerCard/styles'
import { onDownloadFile } from 'src/hooks'
import { useLocales } from 'src/locales'

type Document = UploadFile & { id?: string }

export const PatientQuestionnaireDetails = () => {
  const { id } = useParams()

  const { t } = useLocales()
  const { styles } = useStyles()

  const { data: personDetails } = usePersonsServiceGetPersonEndpoint()

  const { data: quizDetails, isLoading: isQuizLoading } =
    useQuestionnairesServiceGetQuestionnaireEndpoint(
      {
        id: String(id)
      },
      [String(id)],
      {
        enabled: !!personDetails?.id
      }
    )

  const { data: quizAnswers, isLoading } =
    useQuestionnairesServiceGetQuestionnaireAnswerEndpoint(
      {
        id: String(id),
        personId: String(personDetails?.id)
      },
      [String(id), String(personDetails?.id)],
      {
        enabled: !!personDetails?.id
      }
    )

  const mappedQuestions = mapAnswersToQuizDetails(
    quizDetails,
    quizAnswers?.questions
  )

  if (isLoading || isQuizLoading) {
    return <LoadingScreen />
  }

  return (
    <Card className={styles.card}>
      <Flex vertical className={styles.questionAnswerWrapper} gap={48}>
        <QuizDetailsForm data={mappedQuestions} />

        <Upload
          itemRender={(_, file: Document) => (
            <CustomItemRender
              file={file}
              onDownload={() => onDownloadFile(t, file?.id, file?.name)}
            />
          )}
          fileList={quizAnswers?.mediaFiles?.map(
            (file: MediaFileResponse3, index: number) => ({
              ...file,
              uid: String(file?.id ?? index),
              name: file?.name ?? `file-${index}`
            })
          )}
          disabled
        />
      </Flex>
    </Card>
  )
}
